module.exports = __webpack_public_path__ + "static/img02-ae0b081ceff2a0833d9eaf3617c650a8.png";